<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import helperFile from "../../../helpers/helper";
export default {
  page: {
    title: "Restaurant License",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: { Layout, PageHeader },
  data() {
    return {
      tableData: [],
      title: "Restaurant License",
      items: [
        {
          text: "View",
        },
        {
          text: "Restaurant License",
          active: true,
        },
      ],
      totalRows: 1,
      currentPage: 1,
      perPage: 15,
      pageOptions: [15, 25, 50, 100, 500, 1000, 2000, "All"],
      filter: null,
      filterOn: [],
      sortBy: "age",
      sortDesc: false,
      fields: [
        {
          key: "sno",
          label:"S.No.",
          tdClass: "align-center",
          sortable: true,
        },{
          key: "name",
          sortable: true,
          tdClass: "align-center",
        },
        {
          key: "address",
          sortable: true,
        },
        {
          key: "Location",
          sortable: true,
        },
        {
          key: "documentName",
          sortable: true,
        },
        {
          key: "documentNumber",
          sortable: true,
        },
        {
          key: "expiryDate",
          sortable: true,
          tdClass: "align-right",
        }, {
          key: "bankName",
          sortable: true,
          tdClass: "align-right",
        }, {
          key: "accountNO",
          sortable: true,
          tdClass: "align-right",
        }, {
          key: "ifscCode",
          sortable: true,
          tdClass: "align-right",
        }, {
          key: "payu_qr_id",
          sortable: true,
          tdClass: "align-right",
        },{
          key: "revenue_share",
          sortable: true,
          label:"Revenue Share (%)",
          tdClass: "align-right",
        },

        {
          key: "documentFile",
          sortable: true,
          tdClass: "align-right",
        },
      ],
    };
  },
  computed: {
    /**
     * Total no. of records
     */
    rows() {
      return this.tableData.length;
    },
  },
  mounted() {
    // Set the initial number of items
    this.totalRows = this.items.length;
    this.readRestaurantLicenseData();
    this.substring = helperFile.substringFunction;
  },
  methods: {
    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    readRestaurantLicenseData() {
      this.axios
          .post(this.$loggedRole+"/get-restaurant-license", {
            empTypeID: this.$storageData.profile.empTypeID,
            empID: this.$storageData.profile.pid,
            loginTypeID: this.$storageData.login_type,
          })
          .then((response) => {
            this.tableData = response.data.data;
          });
    },
    downloadSample() {
      this.axios
          .post(this.$loggedRole + "/exportExcel",
              {
                exportData: this.tableData,
                page: "RestaurantLicense",
              },
              {
                responseType: "blob",
              }
          )
          .then((response) => {
            const url = URL.createObjectURL(
                new Blob([response.data], {
                  type: "application/vnd.ms-excel",
                })
            );
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", "restaurant-license.xlsx");
            document.body.appendChild(link);
            link.click();
          });
    },
  },
  middleware: "authentication",
}
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row mt-4">
              <div class="col-sm-12 col-md-4" style="margin-bottom: 15px;" v-if="$can('download restaurant license')">
                <div role="group" class="btn-group">
                  <button
                      type="button"
                      class="btn btn-themeBrown"
                      @click="downloadSample()"
                  >
                    Excel
                  </button>
                </div>
              </div>
              <div class="col-sm-12 col-md-4">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show &nbsp;&nbsp;
                    <b-form-select
                        style="margin-left: 5px; margin-right: 5px"
                        v-model="perPage"
                        size="sm"
                        :options="pageOptions"
                    ></b-form-select
                    >&nbsp;&nbsp;&nbsp; entries
                  </label>
                </div>
              </div>
              <!-- Search -->
              <div class="col-sm-12 col-md-4 row">
                <div
                    id="tickets-table_filter"
                    class="dataTables_filter text-md-end"
                >
                  <label class="d-inline-flex align-items-center">
                    Search:
                    <b-form-input
                        v-model="filter"
                        type="search"
                        placeholder="Search..."
                        class="form-control form-control-sm ms-2"
                    ></b-form-input>
                  </label>
                </div>
              </div>
              <!-- End search -->
            </div>
            <!-- Table -->
            <div class="table-responsive mb-0 table-striped">
              <b-table
                  striped
                  hover
                  outlined
                  bordered
                  :items="tableData"
                  :fields="fields"
                  responsive
                  :per-page="perPage"
                  :current-page="currentPage"
                  :sort-by.sync="sortBy"
                  :sort-desc.sync="sortDesc"
                  :filter="filter"
                  :filter-included-fields="filterOn"
                  @filtered="onFiltered"
              >
                <template v-slot:cell(sno)="data">
                  <span>
                   {{ (currentPage - 1) * perPage + data.index + 1 }}
                  </span>
                </template>

                <template v-slot:cell(address)="data">
                  <span :title="data.item.address">{{
                      substring(data.item.address)
                    }}</span>
                </template>
                <template v-slot:cell(Location)="data">
                  <span>{{ data.item.branchName }}</span>
                </template>
                <template v-slot:cell(documentFile)="data">
                  <span><a :href=" data.item.documentFile" target="_blank">{{ data.item.documentFile }}</a></span>
                </template>
              </b-table>
            </div>
            <div class="row">
              <div class="col">
                <div
                    class="dataTables_paginate paging_simple_numbers float-end"
                >
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination
                        v-model="currentPage"
                        :total-rows="rows"
                        :per-page="perPage"
                    ></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<style scoped>

</style>